import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "_mb-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_base_button = _resolveComponent("base-button")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    title: $options.title,
    icon: "user",
    "is-visible": $options.isVisible,
    "has-backdrop": "",
    "show-action-close": "",
    onActionClose: $options.onClose,
    onAfterEnter: $options.onAfterEnter
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString($options.message), 1 /* TEXT */),
      ($options.isNicknameFieldVisible)
        ? (_openBlock(), _createBlock(_component_text_field, {
            key: 0,
            ref: "nickname",
            modelValue: _ctx.model.nickname,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.model.nickname) = $event)),
            name: "model.nickname",
            "is-required": "",
            class: "_mt-0 _mr-1 _grow-1",
            "display-name": _ctx.Resources.Profile.UserFollowSettingsNicknameLabel,
            placeholder: _ctx.Resources.Profile.UserFollowSettingsNicknameLabel,
            "show-label": "",
            onKeyup: [
              _withKeys($options.onFollow, ["enter"]),
              _withKeys($options.onClose, ["esc"])
            ],
            "data-qa": "modal-field:Nickname"
          }, null, 8 /* PROPS */, ["modelValue", "display-name", "placeholder", "onKeyup"]))
        : _createCommentVNode("v-if", true),
      ($options.isPublicFieldVisible)
        ? (_openBlock(), _createBlock(_component_checkbox_field, {
            key: 1,
            modelValue: _ctx.model.isPublic,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.model.isPublic) = $event)),
            "show-label": "",
            condensed: "",
            "display-name": _ctx.Resources.Profile.UserFollowSettingsPublicProfileFieldName,
            name: "model.isPublic",
            class: "_mt-5",
            "label-class": "_flex",
            "data-qa": "modal-checkbox:IsProfilePublic"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.Profile.UserFollowSettingsMakeMyProfilePublicLabel), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue", "display-name"]))
        : _createCommentVNode("v-if", true)
    ]),
    actions: _withCtx(() => [
      _createElementVNode("button", {
        class: "gfu-link gfu-link--accent",
        type: "button",
        onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.onClose && $options.onClose(...args)), ["prevent"])),
        "data-qa": "modal-button:Cancel"
      }, _toDisplayString(_ctx.Resources.Profile.UserFollowSettingsCancelButton), 1 /* TEXT */),
      _createVNode(_component_tooltip, {
        text: $options.followRestrictionReason,
        enabled: $options.hasErrors
      }, {
        default: _withCtx(() => [
          _createVNode(_component_base_button, {
            theme: "accent",
            type: "submit",
            disabled: $options.hasErrors,
            onClick: $options.onFollow,
            "data-qa": "modal-button:Follow"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.Profile.UserFollowAction), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled", "onClick"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["text", "enabled"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title", "is-visible", "onActionClose", "onAfterEnter"]))
}